import axios from 'axios';

import {
  isValidPhone as brIsValidPhone,
  isValidCpf as brIsValidCpf,
  isValidCnpj as brIsValidCnpj,
  isValidCep as brIsValidCep,
} from '@brazilian-utils/validators';

export const validateCepAsync = (value = '') => axios.get(`https://viacep.com.br/ws/${value}/json`);

// export const validateCepAsync = (value = '') => axios.get(`https://viacep.com.br/ws/${value}/json`);

export const isValidCep = (val) => (val ? brIsValidCep(val) : true);

export const isValidCpf = (val) => (val ? brIsValidCpf(val) : true);

export const isValidCnpj = (val) => (val ? brIsValidCnpj(val) : true);

export const isValidPhone = (val) => (val ? brIsValidPhone(val) : true);

export const isValidCpfOrCnpj = (val) => (val ? (isValidCpf(val) || isValidCnpj(val)) : true);

export const areValidAuthorizationHeaders = (headers = {}) => (
  Object.prototype.hasOwnProperty.call(headers, 'access-token')
  && Object.prototype.hasOwnProperty.call(headers, 'client')
  && Object.prototype.hasOwnProperty.call(headers, 'client_id')
  && Object.prototype.hasOwnProperty.call(headers, 'expiry')
  && Object.prototype.hasOwnProperty.call(headers, 'token')
  && Object.prototype.hasOwnProperty.call(headers, 'uid')
);

export const isValidUrl = (val) => {
  if (!val) { return true; }

  const pattern = new RegExp('^(https?:\\/\\/)?' // protocol
  + '((([a-z\\d]([a-z\\d-]*[a-z\\d])*)\\.)+[a-z]{2,}|' // domain name
  + '((\\d{1,3}\\.){3}\\d{1,3}))' // OR ip (v4) address
  + '(\\:\\d+)?(\\/[-a-z\\d%_.~+]*)*' // port and path
  + '(\\?[;&a-z\\d%_.~+=-]*)?' // query string
  + '(\\#[-a-z\\d_]*)?$', 'i'); // fragment locator

  return !!pattern.test(val);
};

export default {
  validateCepAsync,
  isValidPhone,
  isValidCep,
  isValidCnpj,
  isValidCpfOrCnpj,
};
